/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "DraftPortfolioPageService";
const log: any = LoggerModule.getInstance();

export class DraftPortfolioPageService {
  private static instance: DraftPortfolioPageService;
  private vapp: VApplication;
  private formData: any = [];
  private credentialForm: any = [];
  private evidenceKanbanList: any = [];
  private createPortfolio: any = {};
  private portfolioTempId: string = null;
  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(
    props: any = {}
  ): DraftPortfolioPageService {
    if (!DraftPortfolioPageService.instance) {
      DraftPortfolioPageService.instance =
        new DraftPortfolioPageService(props);
    }
    return DraftPortfolioPageService.instance;
  }

  public setFormData(args: any) {
    console.log(`args in set form data`, args);
    let _found = false;
    let tempFormData: any = this.formData;
      this.formData.forEach((element: any, index: number) => {
        if (element?.id === args?.id) {
          tempFormData[index] = {...element, ...args?.formData}
          _found = true;
        }
      });
    if(_found === false) {
      console.log(`found or not found`, _found);
      tempFormData.push({
        ...args?.formData,
      id:args?.id});
    }

    console.log(`set form data value`, tempFormData);

    this.formData = tempFormData;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Template Form
    compProps = await agent.getPortfolioFormProps(args);
    console.log('credential portfolio temp id', compProps);
    if (compProps) {
      this.credentialForm = compProps;
      this.portfolioTempId = compProps?.portfolio?.portfolioTempId
      content = { ...content, ...compProps };
    }

    //   //Evidence Kanban Props
    //   compProps = await agent.getEvidenceKanbanProps({});
    //   if (compProps) {
    //     content = { ...content, ...compProps };
    //     this.evidenceKanbanList = compProps.evidenceKanbanList;
    //   }

    //   //CreateTemplate Props
    //   compProps = await agent.getCreateTemplateProps({});
    //   if (compProps) {
    //     content = { ...content, ...compProps, ...this.createPortfolio };
    //   }

    return content;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public submitCredentialForm(args: any) {
    this.setFormData(args);
    let _args = {
      ...args,
      tempId: this.portfolioTempId
    }
    const agent = getAgent();
    return agent.getSavePortfolio(_args);
  }

  public submitForReview() {
    const agent = getAgent();
    const _args = {
      submit: true,
      tempId: this.portfolioTempId
    };
    return agent.getSubmitPortfolio(_args);
  }

  public getFormDefaultData() {
    console.log(`default data`, this.formData);
    const agent = getAgent();
    let formProps: any = {};
    let _args = {
      formData: this.formData,
      credentialForm: this.credentialForm
    }
    formProps = agent.getPortfolioPreviewContentSync(_args);
    return formProps;
  }

  public getDefaultData(){
    console.log(`default data`, this.formData);
    return this.formData;
  }

  // public async initiateDraft(){
  //   const agent = getAgent();
  //   const _args = {
  //     submit:false
  //   };
  //   return await agent.getSubmitPortfolio(_args);
  // }

}